import { ENDPOINTS_ENUM, getEndpoint } from "common/backend/endpoints"
import axios from 'axios'

export const getPublicCatalogToken = async (shortUrl) => {
    try {
        const publicShortEndpoint = getEndpoint(ENDPOINTS_ENUM.PUBLIC_SHORT)
        const res = await axios.get(`${publicShortEndpoint}${shortUrl}`)
        const token = res.data.metaData.token
        return token
    } catch (err) {
      return Promise.reject(err)
    }
}

export default getPublicCatalogToken
